/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi__filters__search_range__value = /** @type {(inputs: { value: NonNullable<unknown> }) => string} */ (i) => {
	return `Bis zu ${i.value} km`
};

const en_zoi__filters__search_range__value = /** @type {(inputs: { value: NonNullable<unknown> }) => string} */ (i) => {
	return `Up to ${i.value} km`
};

const es_zoi__filters__search_range__value = /** @type {(inputs: { value: NonNullable<unknown> }) => string} */ (i) => {
	return `Hasta ${i.value} km`
};

const fr_zoi__filters__search_range__value = /** @type {(inputs: { value: NonNullable<unknown> }) => string} */ (i) => {
	return `Jusqu’à ${i.value} km`
};

const it_zoi__filters__search_range__value = /** @type {(inputs: { value: NonNullable<unknown> }) => string} */ (i) => {
	return `Fino a ${i.value} km`
};

const nl_zoi__filters__search_range__value = /** @type {(inputs: { value: NonNullable<unknown> }) => string} */ (i) => {
	return `Maximaal ${i.value} km`
};

const pt_zoi__filters__search_range__value = /** @type {(inputs: { value: NonNullable<unknown> }) => string} */ (i) => {
	return `Até ${i.value} km`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ value: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__value = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi__filters__search_range__value(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi__filters__search_range__value", locale)
	if (locale === "de") return de_zoi__filters__search_range__value(inputs)
	if (locale === "en") return en_zoi__filters__search_range__value(inputs)
	if (locale === "es") return es_zoi__filters__search_range__value(inputs)
	if (locale === "fr") return fr_zoi__filters__search_range__value(inputs)
	if (locale === "it") return it_zoi__filters__search_range__value(inputs)
	if (locale === "nl") return nl_zoi__filters__search_range__value(inputs)
	return pt_zoi__filters__search_range__value(inputs)
};